(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.announcementBar = document.querySelector('.announcement-bar');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      if(this.dataset.template == "index"){
        this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        this.mainContent = document.querySelector('main');
        
        // Create observer for search changes
        if (this.mainContent) {
          const searchObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (this.mainContent.classList.contains('nosto-serp-content')) {
                  this.classList.add('header-bg-white');
                  this.classList.remove('header-wrapper--text-white');
                }
              }
            });
          });

          searchObserver.observe(this.mainContent, { attributes: true });
        }
      }

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);

      if (this.announcementBar) {
        const updateAnnouncementHeight = () => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const announcementHeight = this.announcementBar.offsetHeight;
          
          if (scrollTop < announcementHeight) {
            document.documentElement.style.setProperty('--announcement-bar-height', `${announcementHeight - scrollTop}px`);
          } else {
            document.documentElement.style.setProperty('--announcement-bar-height', '0px');
          }
        };

        updateAnnouncementHeight();
        window.addEventListener('scroll', updateAnnouncementHeight);
        document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onMouseEnter() {
      if (this.dataset.template === 'index') {
        this.classList.add('header-bg-white');
        this.classList.remove('header-wrapper--text-white');
      }
    }

    onMouseLeave() {
      if (this.dataset.template === 'index') {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop === 0 && !this.mainContent.classList.contains('nosto-serp-content')) {
          this.classList.remove('header-bg-white');
          this.classList.add('header-wrapper--text-white');
        }
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        
        if (this.dataset.template === 'index') {
          this.classList.add('header-bg-white');
          this.classList.remove('header-wrapper--text-white');
        }

        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');

        if (this.dataset.template === 'index') {
          if (this.mainContent.classList.contains('nosto-serp-content')) {
            this.classList.add('header-bg-white');
            this.classList.remove('header-wrapper--text-white');
          } else if (scrollTop === 0) {
            this.classList.remove('header-bg-white');
            this.classList.add('header-wrapper--text-white');
          } else {
            this.classList.add('header-bg-white');
            this.classList.remove('header-wrapper--text-white');
          }
        }
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    createMainContentObserver() {
      if (!this.mainContent) return;
      
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (this.dataset.template === 'index') {
              if (this.mainContent.classList.contains('nosto-serp-content')) {
                this.classList.add('header-bg-white');
                this.classList.remove('header-wrapper--text-white');
              } else {
                this.classList.remove('header-bg-white');
                this.classList.add('header-wrapper--text-white');
              }
            }
          }
        });
      });

      // Initial check
      if (this.dataset.template === 'index' && this.mainContent.classList.contains('nosto-serp-content')) {
        this.classList.add('header-bg-white');
        this.classList.remove('header-wrapper--text-white');
      }

      observer.observe(this.mainContent, { attributes: true });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
